var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClockAlertOutline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MDI_clock-alert-outline",
    "data-name": "MDI / clock-alert-outline",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_clock-alert-outline",
    "data-name": "Path / clock-alert-outline",
    d: "M16.4,10v9.6l8.32,4.96L26,22.64l-7.2-4.32V10H16.4m14.4,8v9.6H34V18H30.8m0,12.8V34H34V30.8H30.8m-3.2,0A15.413,15.413,0,0,1,18,34,16,16,0,1,1,33.68,14.8H30.32A12.768,12.768,0,1,0,18,30.8a13.172,13.172,0,0,0,9.6-4.32Z",
    fill: "#ef233c"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClockAlertOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clock-alert-outline.d5e5f54ea60ed9022891f32718490301.svg";